import { createNgReactBridgeDirective } from '../../react-bridge'
import { ApplicationMetadata } from '../../../components/application-details'

export const applicationMetadata = createNgReactBridgeDirective(
  'reactApplicationMetadata',
  [],
  ApplicationMetadata,
  ['organizationID', 'applicationID', 'organizationRole']
)
